import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { NotificationSettings } from 'mbs-ui-shared@models/Notification';
import { NotificationOptionsService } from 'mbs-ui-shared@services/notification-options.service';
import { pipe } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

export type NotificationOptionsState = {
  settings: NotificationSettings;
  loading: boolean;
  loaded: boolean;
};

export const initialNotificationOptionsState: NotificationOptionsState = {
  settings: null,
  loading: false,
  loaded: false
};

export const NotificationOptionsStore = signalStore(
  { providedIn: 'root' },
  withDevtools('NotificationOptionsStore'),
  withState(initialNotificationOptionsState),
  withMethods((store, service = inject(NotificationOptionsService)) => ({
    load: rxMethod<{ silent?: boolean; force?: boolean }>(
      pipe(
        filter(({ force }) => force || !store.loaded()),
        tap(({ silent }) => !silent && patchState(store, { loading: true })),
        switchMap(() => {
          return service.get().pipe(
            tapResponse({
              next: (settings) => patchState(store, { settings }),
              error: () => void 0,
              finalize: () => patchState(store, { loading: false, loaded: true })
            })
          );
        })
      )
    ),
    update(settings: NotificationSettings): void {
      patchState(store, (state) => ({ ...state, settings }));
    }
  }))
);
